module.exports = __webpack_public_path__ + "static/media/Graphics_1.68897106.png";